module.exports = __webpack_public_path__ + "static/img/s_hydrafacial.cd3a27a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/services/s_hydrafacial.jpg
// module id = 100
// module chunks = 1